import { z } from 'zod';

/**
 * Full defintion of our representation of Video23 data properties.
 *
 * NB: We only keep the properties we actually need, even though 23Video sends
 * a lot more
 *
 * NB: Currently the handlers for video23 only supports audio, but should be
 * fairly easily extensible to support video as well.
 */
const video23AudioDataSchema = z.object({
  photoId: z.string(),
  title: z.string(),
  token: z.string(),
  src: z.string(),
  description: z.string().nullish().default(null),
  thumbnail: z.object({
    src: z.string(),
    width: z.number(),
    height: z.number()
  }).nullish().default(null),
  transcript: z.array(z.any()).nullish().default(null)
});

/**
 * Partial typings of a video23 response
 *
 * NB: The actual response contains a lot more fields.
 */

export { video23AudioDataSchema };
//# sourceMappingURL=typings.video23.js.map
